import React from "react"
import styles from "./cloudsmartjoinus.css"

const CloudSmartJoinus = (props) => {

  return (
    <section className="join" id="Joinus">
      
      <div className="joinuswrap">
      <div className="containfix">
        <div className="joinus">
          <div className="jtext">
            JOIN US!
          </div>
          <div className="colcenter"></div>
          <div className="regcol">
            <a className="regop" href="https://event.on24.com/wcc/r/2542643/5EC1967FB1D88F16AE1DF85810FBB7E9" target="_blank">REGISTER »</a>
          </div>
        </div>
      </div>
      </div>
    </section>
  )
}

export default CloudSmartJoinus